import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SuccessBox from 'components/Web_User_Interface/1080p_Series/System/Backup/SuccessBox';
import BackupTable from 'components/Web_User_Interface/1080p_Series/System/Backup/backupTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Software Backup",
  "path": "/Web_User_Interface/1080p_Serie/System/Backup/",
  "dateChanged": "2017-12-11",
  "author": "Mike Polinowski",
  "excerpt": "Sichern Sie Ihre Kameraeinstellungen.",
  "image": "./WebUI_1080p_SearchThumb_System_Update.png",
  "social": "/images/Search/WebUI_1080p_SearchThumb_System_Update.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1080p Web User Interface"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const EuiSpacer = makeShortcode("EuiSpacer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // Software Backup' dateChanged='2017-12-11' author='Mike Polinowski' tag='INSTAR IP Camera' description='Sichern Sie Ihre Kameraeinstellungen.' image='/images/Search/WebUI_1080p_SearchThumb_System_Update.png' twitter='/images/Search/WebUI_1080p_SearchThumb_System_Update.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1080p_Series/System/Backup/' locationFR='/fr/Web_User_Interface/1080p_Series/System/Backup/' crumbLabel="Backup" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "1080p-web-user-interface",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#1080p-web-user-interface",
        "aria-label": "1080p web user interface permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`1080p Web User Interface`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/02d56c6c0eec6576f913ca53ef85c70b/8dd93/1080p_Settings_System_Backup.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC2UlEQVQoz32SW0gUURjHTxaUeElZL7X60Cqurle8o0WZFSGKa7okaJpKJhKBzu6cOTO7M3OmEcKEpJAuGqhbD0KB1EMgaqb5UCYUEl56yoIgwnRdcXfVmROzivTUjz+Hcw7fn+9/OB+AEDIaiEO09db95ntT17rHm+6O13aO7aumc7S+a7Sl512b/Fi0o4bGRlNKamZWNqAhAxnEshxto7of9k9/dU/O/5ladL1dcE0srE3Mr72ZX51acH9c2lr6Tfr7hm6YKxrLLGW5BYWmFGCFjI1mOI5rp6hnT52EbKvbHqLuEKISDW11K6szrskl8mV2ZISvvileugIvni7NyAGQQTRELMdRFDU4MKisuXyrq95Nj8/jVRVFUXaISn5sfB/41v/K/XpsaFiutnS30iVF9empOcBKMzaIuD3zANn0qO4N4vURr4d4PMTn9WtL3VEIISvvhz9QaXM9zS8cVMvZTIAQggxjt9spinI6nVpQ1UeI4s9MtlXiVcj2juJbXyOEDPR0lcQf66qMm2yJeV5nAgyDbFB7s9Vq7e3tdc+9XJ9+sL78ecW1SYhvZvHXo7HlqbFPP/ueeEdGMd8RqdNHR8Wm6sPb8iO1zlpympEkbDZXROh0MTH6yKjjteeS2qrz7lw91W4xl+Sm3cZCU11Nmik5zhAfFhYaHhx43hCkmWmIaBrKslxcXAwAOBgQkKUDSZEAAFBlPDpbHtpgDCk0VyQW5BqMBr0hJjDoSPDhA4X6Q5rZBhkaMhhji6UqTBddnnei4YIhJCI2KzEBJydDY0JRemp+6ZnK1uqq65fzS06mZ2ckpZkMRiOg/V+FEMuyLM/zGGNZwqKIsYRljGUR0yLmBEFw8FgUOzpkLElYKxAljAFC7K4TIVYQBEmSNN8eWp0s7YGx5vHf4t0j4Dh2V/udRfw/RD+7e0BpQ8JQtDbhDofDronneV7ws1/3r1kQBJ7n7Xb7X8TwtGSS/qRdAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/02d56c6c0eec6576f913ca53ef85c70b/e4706/1080p_Settings_System_Backup.avif 230w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/d1af7/1080p_Settings_System_Backup.avif 460w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/7f308/1080p_Settings_System_Backup.avif 920w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/19805/1080p_Settings_System_Backup.avif 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/02d56c6c0eec6576f913ca53ef85c70b/a0b58/1080p_Settings_System_Backup.webp 230w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/bc10c/1080p_Settings_System_Backup.webp 460w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/966d8/1080p_Settings_System_Backup.webp 920w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/61eb3/1080p_Settings_System_Backup.webp 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/02d56c6c0eec6576f913ca53ef85c70b/81c8e/1080p_Settings_System_Backup.png 230w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/08a84/1080p_Settings_System_Backup.png 460w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/c0255/1080p_Settings_System_Backup.png 920w", "/de/static/02d56c6c0eec6576f913ca53ef85c70b/8dd93/1080p_Settings_System_Backup.png 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/02d56c6c0eec6576f913ca53ef85c70b/c0255/1080p_Settings_System_Backup.png",
              "alt": "Web User Interface - 1080p Series - System Backup",
              "title": "Web User Interface - 1080p Series - System Backup",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <BackupTable mdxType="BackupTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      